import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { silentLogout } from "store/bailiff/login/login.action";
import { isLoggedSelector as loggedASelector } from "store/user/auth/user_auth.selector";
// import { isLoggedSelector as loggedBSelector } from "store/bailiff/auth/bailiff_auth.selector";
import { usePrev } from "hook/usePrev";
//
//component
//redux
//selector
//actions
const TriggerLogOut = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const Alogged = useSelector(loggedASelector);
  const prevALogged = usePrev(Alogged);
  // const Blogged = useSelector(loggedBSelector);
  console.log({ Alogged, prevALogged });

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (prevALogged === true && Alogged === false) {
      console.log("silent logout");
      dispatch(silentLogout());
    }
  }, [dispatch, Alogged, prevALogged]);
  // -------------------------- RETURN --------------------------

  return <></>;
};
export default TriggerLogOut;
